export const DASHBOARD_TOGGLE_DARK_MODE = "DASHBOARD_TOGGLE_DARK_MODE"

export const DASHBOARD_PIN_STUDENT = "DASHBOARD_PIN_STUDENT"
export const DASHBOARD_UNPIN_STUDENT = "DASHBOARD_UNPIN_STUDENT"

export const DASHBOARD_SNACKBAR_SUCCESS = "DASHBOARD_SNACKBAR_SUCCESS"
export const DASHBOARD_SNACKBAR_CLOSE = "DASHBOARD_SUCCESS_CLOSE"